import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/api';

export const PROGRAM_DASHBOARD_TAG = 'ProgramDashboard';

export const adminDashboardProgramsApi = createApi({
  reducerPath: 'adminDashboardProgramsApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/admin-dashboard-programs/',
  }),
  tagTypes: [PROGRAM_DASHBOARD_TAG],
  endpoints: builder => ({
    // -- PROGRAMS --
    // List all programs
    getPrograms: builder.query({
      query: () => ({
        url: '',
        params: { limit: 500 }, // TODO: Add filter by organization and remove limit when BE has finished DEV-8090 task
      }),
      providesTags: [PROGRAM_DASHBOARD_TAG],
    }),
    // Search programs
    searchPrograms: builder.query({
      query: ({ search }) => ({
        url: '',
        params: {
          search,
          limit: 500, // TODO: Add filter by organization and remove limit when BE has finished DEV-8090 task
        },
      }),
      providesTags: [PROGRAM_DASHBOARD_TAG],
    }),
    // Fetch a single program by its uuid
    getProgramByUuid: builder.query({
      query: uuid => ({ url: `${uuid}/` }),
    }),
    // Create a new program
    createProgram: builder.mutation({
      query: programData => ({
        url: '',
        method: 'POST',
        data: programData,
      }),
    }),
    // Update a program
    updateProgram: builder.mutation({
      query: ({ programId, programData }) => ({
        url: `${programId}/`,
        method: 'PATCH',
        data: programData, // program id, changed fields
      }),
    }),
  }),
});

export const {
  // Programs
  useGetProgramsQuery,
  useSearchProgramsQuery,
  useGetProgramByUuidQuery,
  useCreateProgramMutation,
  useUpdateProgramMutation,
} = adminDashboardProgramsApi;
